import {
  Edit,
  email,
  ListButton,
  minLength,
  PasswordInput,
  required,
  SaveButton,
  SelectArrayInput,
  ShowButton,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
  usePermissions,
} from "react-admin";

import {
  UserRole,
  USER_ROLES_OPTIONS_ALLOWED_TO_ADD_VIA_ADMIN_PANEL,
} from "@/constants/roles";
import { UserGroupArrayInput } from "@/inputs/UserGroupArrayInput";
import { equalPasswords, formatObjectsToArrayOfIds } from "@/utils";

import { UserActiveInput } from "./UserActiveInput";

const MIN_PASSWORD_LENGTH = 5;

const EditToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Update" />
    <ShowButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const EditActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
    <ShowButton />
  </TopToolbar>
);

export const UserEdit = () => {
  const { permissions } = usePermissions<UserRole[]>();

  return (
    <Edit actions={<EditActions />} mutationMode="pessimistic">
      <SimpleForm toolbar={<EditToolbar />}>
        <TextInput
          source="username"
          helperText="example: John"
          placeholder="Enter Name"
          validate={required()}
        />
        <TextInput
          type="email"
          source="email"
          validate={[required(), email()]}
          helperText="example: temp@domain.com"
          placeholder="Enter Email"
        />
        <UserGroupArrayInput
          source="groups"
          format={formatObjectsToArrayOfIds}
        />
        <SelectArrayInput
          source="roles"
          disabled={!permissions?.includes(UserRole.ADMIN)}
          choices={USER_ROLES_OPTIONS_ALLOWED_TO_ADD_VIA_ADMIN_PANEL}
        />
        <PasswordInput
          source="plainPassword"
          validate={minLength(MIN_PASSWORD_LENGTH)}
        />
        <PasswordInput source="confirmPassword" validate={equalPasswords} />
        <UserActiveInput />
      </SimpleForm>
    </Edit>
  );
};
